import { render, staticRenderFns } from "./add-extra-f-data.vue?vue&type=template&id=493c30de&scoped=true"
import script from "./add-extra-f-data.vue?vue&type=script&lang=js"
export * from "./add-extra-f-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c30de",
  null
  
)

export default component.exports